import React, { useState, useEffect, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { RiLoader4Line } from "react-icons/ri";
import { FilterContext } from "../../context/Filter";

import {
  fetchAccountName,
  fetchArnNumber,
  customerVehicleRegistrationNumber,
  customerKeyAccountLocation,
  fetchChassisNumber,
  fetchPhoneNumber,
  fetchGoldenAccountName,
  fetchCustomerGoldenArn,
} from "./apiSearch";

const Search = () => {
  const [selectedValue, setSelectedValue] = useState("");
  const [placeholder, setPlaceholder] = useState("Please select search type");
  const [isDisabled, setIsDisabled] = useState(true);
  const [value, setValue] = useState("");
  const [arnValue, setIsArn] = useState("");
  const [searchData, setSearchData] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isGoldenArn, setIsGoldenArn] = useState(false);
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(true);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { childData, setChildData } = useContext(FilterContext);
  const { fleetid, setFleetid } = useContext(FilterContext);
  const [parentarn, setparentarn] = useState("");
  const [childarn, setChildarn] = useState("");


  const {
    superArn,
    setSuperArn,
    arn,
    setArn,
    setAccountName,
    setIsGoldenArnD,
    childArn,
    setChildArn,
    isOpen, open,
    setOpen,
  } = useContext(FilterContext);

  // const handleReset = () => {
  //   console.log("reset")
  //   setSearchData("")
  //   setIsGoldenArnD("")
  //   setValue("");
  //   setAccountName("");
  //   setIsArn("");
  //   setSuperArn("");
  //   setChildArn("");
  //   setIsGoldenArn("")
  //   localStorage.removeItem("searchState");

  // }
  const handleReset = () => {
    // Clear local state
    setSearchData("");
    setValue("");
    setIsArn("");
    setIsGoldenArn(false);
    setIsCheckboxChecked(false);

    // Clear context values
    setSuperArn("");   // 👈 parArn / parent ARN cleared
    setChildArn("");
    setArn("");
    setAccountName("");
    setChildArn("")
    setFleetid("")
    setChildData("")

    setIsGoldenArnD(false);

    // Clear dropdown state
    setSelectedValue("");
    setPlaceholder("Please select search type");
    setIsDisabled(true);
    setIsDropdownOpen(false);


    // console.log("Restart → parArn cleared");
  };

  useEffect(() => {
    const savedSearch = localStorage.getItem("searchState");
    if (savedSearch) {
      const parsed = JSON.parse(savedSearch);
      setSelectedValue(parsed.selectedValue || "");
      setValue(parsed.value || "");
      setPlaceholder(parsed.placeholder || "Please select search type");
      setIsCheckboxChecked(parsed.isCheckboxChecked || false);
      setIsCheckboxDisabled(parsed.isCheckboxDisabled || true);
      setIsGoldenArn(parsed.isGoldenArn || false);
      setIsDisabled(parsed.isDisabled ?? true);

      // --- IMPORTANT: If we restored a typed value, set searchData so query hooks enable,
      // and open the dropdown so suggestions (when they arrive) will be visible.
      // if (parsed.value?.trim()) {
      //   setSearchData(parsed.value);
      //   // setIsDropdownOpen(true);
      // }
      if (parsed.value?.trim()) {
        setSearchData(parsed.value);
        // Restore ARN value if it was filled before
        if (parsed.selectedValue === "Account Name" && !parsed.isGoldenArn) {
          setIsArn(parsed.arnValue || "");
        } else if (parsed.selectedValue === "ARN Number") {
          setIsArn(parsed.arnValue || parsed.value); // ARN input mirrors typed value for ARN Number
        }
      }
    }
  }, []);

  // ✅ Save state to localStorage whenever something changes
  // useEffect(() => {
  //   const state = {
  //     selectedValue,
  //     value,
  //     placeholder,
  //     isCheckboxChecked,
  //     isCheckboxDisabled,
  //     isGoldenArn,
  //     isDisabled,
  //   };
  //   localStorage.setItem("searchState", JSON.stringify(state));
  // }, [
  //   selectedValue,
  //   value,
  //   placeholder,
  //   isCheckboxChecked,
  //   isCheckboxDisabled,
  //   isGoldenArn,
  //   isDisabled,
  // ]);

  // useEffect(() => {
  //   const state = {
  //     selectedValue,
  //     value,
  //     placeholder,
  //     isCheckboxChecked,
  //     isCheckboxDisabled,
  //     isGoldenArn,
  //     isDisabled,
  //     arnValue,
  //   };
  //   localStorage.setItem("searchState", JSON.stringify(state));
  // }, [
  //   selectedValue,
  //   value,
  //   placeholder,
  //   isCheckboxChecked,
  //   isCheckboxDisabled,
  //   isGoldenArn,
  //   isDisabled,
  //   arnValue, // <--- add dependency
  // ]);

  // const handleReset = () => {
  //   console.log("reset")

  //   setValue("");
  //   setAccountName("");
  //   setIsArn("");
  //   setSuperArn("");
  //   setChildArn("");
  //   console.log(selectedValue)


  // }

  useEffect(() => {
    const safeState = {
      selectedValue,
      placeholder,
      isCheckboxChecked,
      isCheckboxDisabled,
      isGoldenArn,
      isDisabled,
    };

    localStorage.setItem("searchState", JSON.stringify(safeState));
  }, [
    selectedValue,
    placeholder,
    isCheckboxChecked,
    isCheckboxDisabled,
    isGoldenArn,
    isDisabled,
    setValue,
    setAccountName,
    setIsArn,
    setSuperArn,
    setChildArn
  ]);

  // console.log()
  // -------------------------------
  // Queries
  // -------------------------------
  const { data: AccountName, refetch: refetchAccountName } = useQuery({
    queryKey: ["accountName", searchData],
    queryFn: () => fetchAccountName(searchData),
    enabled: !!searchData && selectedValue === "Account Name" && !isGoldenArn,
  });
  // console.log("accountnamee", AccountName)
  const { data: GoldenAccountName, refetch: refetchGoldenAccountName } =
    useQuery({
      queryKey: ["accountName", searchData],
      queryFn: () => fetchGoldenAccountName(searchData),
      enabled: !!searchData && selectedValue === "Account Name" && isGoldenArn,
    });

  const { data: ArnNumber, refetch: refetchArnNumber } = useQuery({
    queryKey: ["arnNumber", searchData],
    queryFn: () => fetchArnNumber(searchData),
    enabled: !!searchData && selectedValue === "ARN Number" && !isGoldenArn,
  });

  const { data: GoldenArnNumber, refetch: refetchGoldenArnNumber } = useQuery({
    queryKey: ["accountName", searchData],
    queryFn: () => fetchCustomerGoldenArn(searchData),
    enabled: !!searchData && selectedValue === "ARN Number" && isGoldenArn,
  });

  const {
    data: vehicleRegistrationNumber,
    refetch: refetchVehicleRegistrationNumber,
  } = useQuery({
    queryKey: ["vehicleRegNumber", searchData],
    queryFn: () => customerVehicleRegistrationNumber(searchData),
    enabled: !!searchData && selectedValue === "Vehicle Registration Number",
  });

  const { data: KeyAccountLocation, refetch: refetchKeyAccountLocation } =
    useQuery({
      queryKey: ["keyAccountCode", searchData],
      queryFn: () => customerKeyAccountLocation(searchData),
      enabled: !!searchData && selectedValue === "Key Account Code",
    });

  const { data: fetchChassisNumberData, refetch: refetchChassisNumber } =
    useQuery({
      queryKey: ["chassisNumber", searchData],
      queryFn: () => fetchChassisNumber(searchData),
      enabled: !!searchData && selectedValue === "Chassis Number",
    });

  const { data: fetchPhoneNumberData, refetch: refetchPrimaryCntNumber } =
    useQuery({
      queryKey: ["phoneNumber", searchData],
      queryFn: () => fetchPhoneNumber(searchData),
      enabled: !!searchData && selectedValue === "Primary Contact Number",
    });

  // -------------------------------
  // Dropdown options
  // -------------------------------
  const options = [
    {
      label: "Account Name",
      value: "Account Name",
      placeholder: "Enter account name",
    },
    {
      label: "ARN Number",
      value: "ARN Number",
      placeholder: "Enter ARN Number",
    },
    {
      label: "Vehicle Registration Number",
      value: "Vehicle Registration Number",
      placeholder: "Enter vehicle registration number",
    },
    {
      label: "Key Account Code",
      value: "Key Account Code",
      placeholder: "Enter Key Account Code",
    },
    {
      label: "Chassis Number",
      value: "Chassis Number",
      placeholder: "Enter chassis number",
    },
    {
      label: "Primary Contact Number",
      value: "Primary Contact Number",
      placeholder: "Enter Primary Contact Number",
    },
  ];

  const handleDropdownChange = (e) => {
    const selectedOption = options.find(
      (option) => option.value === e.target.value
    );
    setSelectedValue(selectedOption ? selectedOption.value : "");
    setIsArn("");
    setPlaceholder(
      selectedOption ? selectedOption.placeholder : "Please select search type"
    );

    if (
      selectedOption?.value === "Account Name" ||
      selectedOption?.value === "ARN Number"
    ) {
      setIsCheckboxDisabled(false);
      setIsGoldenArn(false);
    } else {
      setIsGoldenArn(false);
      setIsCheckboxDisabled(true);
      setIsCheckboxChecked(false);
    }
    setIsDisabled(!selectedOption);
    setValue("");
  };

  const maskPhoneNumber = (num) => {
    if (!num) return "";
    const str = String(num).trim();
    if (str.length <= 5) return str;
    return str.slice(0, 5) + "*****";
  };

  const handleChange = async (e) => {
    const inputValue = e.target.value;
    setValue(inputValue);
    setSearchData(inputValue);
    // console.log("firstvalue", searchData)

    setIsDropdownOpen(true);

    if (inputValue.trim()) {
      setIsLoading(true);
      try {
        await new Promise((resolve) => setTimeout(resolve, 2000));
      } catch (error) {
        console.error("Error during fetch:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleChecBox = (e) => {
    const inputValue = e.target.checked;
    setIsGoldenArn(inputValue);
    setValue("");
    setIsArn("");
    setIsDropdownOpen(true);
    setIsGoldenArnD(true);
    setIsCheckboxChecked((prev) => !prev);
  };

  // const handleSuggestionClick = (result) => {
  //   if (selectedValue === "Account Name" && !isGoldenArn) {
  //     // setValue(result?.buckets);
  //     setValue(bucket.key);
  //     setAccountName(bucket.key);
  //     // setAccountName(result?._source?.PAR_ACCNT_NAME1);
  //     setparentarn(result?._source?.PAR_ACCNT_ARN)
  //     setChildarn(result?._source?.ACCNT_ARN)
  //     setIsArn(result._source.PAR_ACCNT_ARN);
  //     setSuperArn(result._source.PAR_ACCNT_ARN);
  //     setChildArn("");
  //   } else if (selectedValue === "ARN Number" && !isGoldenArn) {
  //     setValue(result._source.PAR_ACCNT_ARN);
  //     setAccountName(result?._source?.PAR_ACCNT_NAME);
  //     setIsArn(result._source.PAR_ACCNT_ARN);
  //     setSuperArn(result._source.PAR_ACCNT_ARN);
  //     setChildArn("");
  //   } else if (selectedValue === "Vehicle Registration Number") {
  //     setValue(result._source.VEHICLE_REGISTRATION_NUMBER);
  //     setIsArn(result._source.PAR_ACCNT_ARN);
  //     setSuperArn(result._source.PAR_ACCNT_ARN);
  //     setAccountName(result?._source?.PAR_ACCNT_NAME);
  //     setChildArn("");
  //   } else if (selectedValue === "Key Account Code") {
  //     setValue(result._source.PAR_ACCNT_LOCATION);
  //     setIsArn(result._source.PAR_ACCNT_ARN);
  //     setSuperArn(result._source.PAR_ACCNT_ARN);
  //     setAccountName(result?._source?.PAR_ACCNT_NAME);
  //     setChildArn("");
  //   } else if (selectedValue === "Chassis Number") {
  //     setValue(result._source.ASSET_NUMBER);
  //     setIsArn(result._source.PAR_ACCNT_ARN);
  //     setSuperArn(result._source.PAR_ACCNT_ARN);
  //     setAccountName(result?._source?.PAR_ACCNT_NAME);
  //     setChildArn("");
  //   } else if (selectedValue === "Primary Contact Number") {
  //     setValue(result._source.PAR_ACCNT_MAIN_PH_NUM);
  //     setIsArn(result._source.PAR_ACCNT_ARN);
  //     setSuperArn(result._source.PAR_ACCNT_ARN);
  //     setAccountName(result?._source?.PAR_ACCNT_NAME);
  //     setChildArn("");
  //   } else if (selectedValue === "Account Name" && isGoldenArn) {
  //     setValue(result._source.PAR_ACCNT_NAME);
  //     setIsArn(result._source.PAR_ACCNT_ARN);
  //     setSuperArn(result._source.PAR_ACCNT_ARN);
  //     setAccountName(result?._source?.PAR_ACCNT_NAME);
  //     setChildArn("");
  //   } else if (selectedValue === "ARN Number" && isGoldenArn) {
  //     setValue(result._source.PAR_ACCNT_ARN);
  //     setIsArn(result._source.PAR_ACCNT_ARN);
  //     setSuperArn(result._source.PAR_ACCNT_ARN);
  //     setAccountName(result?._source?.PAR_ACCNT_NAME);
  //     setChildArn("");
  //   }
  //   setIsDropdownOpen(false);
  // };
  const handleSuggestionClick = (result, type = null) => {
    if (selectedValue === "Account Name" && !isGoldenArn && type === 'parent') {
      const source = result?.parent_source?.hits?.hits?.[0]?._source;

      if (!source) return;

      setValue(result.key);

      setAccountName(result.key);

      setparentarn(source.PAR_ACCNT_ARN);
      setChildarn("");

      setIsArn(source.PAR_ACCNT_ARN);
      setSuperArn(source.PAR_ACCNT_ARN);
      setChildArn("");
    }

    else if (selectedValue === "Account Name" && !isGoldenArn && type === 'child') {
      const source = result._source;

      if (!source) return;

      setValue(source.PAR_ACCNT_NAME1);
      setAccountName(source.PAR_ACCNT_NAME1);

      setparentarn(source.PAR_ACCNT_ARN);
      setChildarn(source.ACCNT_ARN);

      setIsArn(source.ACCNT_ARN);
      setSuperArn(source.PAR_ACCNT_ARN);
      setChildArn(source.ACCNT_ARN);
    }

    // 🔹 ARN NUMBER (NON-GOLDEN) — OLD _source BASED
    else if (selectedValue === "ARN Number" && !isGoldenArn) {
      setValue(result._source.PAR_ACCNT_ARN);
      setAccountName(result?._source?.PAR_ACCNT_NAME);
      setIsArn(result._source.PAR_ACCNT_ARN);
      setSuperArn(result._source.PAR_ACCNT_ARN);
      setChildArn("");
    }

    // 🔹 VEHICLE REG NUMBER
    else if (selectedValue === "Vehicle Registration Number") {
      setValue(result._source.VEHICLE_REGISTRATION_NUMBER);
      setIsArn(result._source.PAR_ACCNT_ARN);
      setSuperArn(result._source.PAR_ACCNT_ARN);
      setAccountName(result?._source?.PAR_ACCNT_NAME);
      setChildArn("");
    }

    else if (selectedValue === "Key Account Code") {
      setValue(result._source.PAR_ACCNT_LOCATION);
      setIsArn(result._source.PAR_ACCNT_ARN);
      setSuperArn(result._source.PAR_ACCNT_ARN);
      setAccountName(result?._source?.PAR_ACCNT_NAME);
      setChildArn("");
    }

    else if (selectedValue === "Chassis Number") {
      setValue(result._source.ASSET_NUMBER);
      setIsArn(result._source.PAR_ACCNT_ARN);
      setSuperArn(result._source.PAR_ACCNT_ARN);
      setAccountName(result?._source?.PAR_ACCNT_NAME);
      setChildArn("");
    }

    else if (selectedValue === "Primary Contact Number") {
      setValue(result._source.PAR_ACCNT_MAIN_PH_NUM);
      setIsArn(result._source.PAR_ACCNT_ARN);
      setSuperArn(result._source.PAR_ACCNT_ARN);
      setAccountName(result?._source?.PAR_ACCNT_NAME);
      setChildArn("");
    }

    else if (selectedValue === "Account Name" && isGoldenArn) {
      setValue(result._source.PAR_ACCNT_NAME);
      setIsArn(result._source.PAR_ACCNT_ARN);
      setSuperArn(result._source.PAR_ACCNT_ARN);
      setAccountName(result?._source?.PAR_ACCNT_NAME);
      setChildArn("");
    }

    else if (selectedValue === "ARN Number" && isGoldenArn) {
      setValue(result._source.PAR_ACCNT_ARN);
      setIsArn(result._source.PAR_ACCNT_ARN);
      setSuperArn(result._source.PAR_ACCNT_ARN);
      setAccountName(result?._source?.PAR_ACCNT_NAME);
      setChildArn("");
    }

    setIsDropdownOpen(false);
  };

  useEffect(() => {
    if (searchData) {
      if (selectedValue === "Account Name" && !isGoldenArn) {
        refetchAccountName();
      } else if (selectedValue === "ARN Number") {
        refetchArnNumber();
      } else if (selectedValue === "Vehicle Registration Number") {
        refetchVehicleRegistrationNumber();
      } else if (selectedValue === "Key Account Code") {
        refetchKeyAccountLocation();
      } else if (selectedValue === "Chassis Number") {
        refetchChassisNumber();
      } else if (selectedValue === "Primary Contact Number") {
        refetchPrimaryCntNumber();
      } else if (selectedValue === "Account Name" && isGoldenArn) {
        refetchGoldenAccountName();
      } else if (selectedValue === "ARN Number" && isGoldenArn) {
        refetchGoldenArnNumber();
      }
    }
  }, [
    searchData,
    selectedValue,
    refetchAccountName,
    refetchArnNumber,
    refetchVehicleRegistrationNumber,
    refetchKeyAccountLocation,
    refetchChassisNumber,
    refetchPrimaryCntNumber,
    refetchGoldenAccountName,
    refetchGoldenArnNumber,
  ]);

  // console.log(searchData, "searchdata")

  return (
    <>
      {isOpen && (
        <div className="p-2 bg-gray-100 rounded-md shadow-md w-full mt-2">
          <div className="  justify-items-center   block md:flex gap-2 md:gap-2 items-center">
            <div className="flex-1 min-w-[200px] p-1 md:p-0">
              <select
                value={selectedValue}

                onChange={handleDropdownChange}
                id="searchType"
                className={`block bg-white text-[#6b6769] ${open ? "w-[200px]" : "w-[350px] "} p-2 rounded-lg border border-slate-200 placeholder:text-[#6b6769]`}
              >
                <option value="" disabled>
                  Select search type
                </option>
                {options.map((options) => (
                  <option key={options.label} value={options.value}>
                    {options.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex-1  flex items-center gap-2">
              <input
                type="checkbox"
                className="h-5 w-5"
                onChange={handleChecBox}
                name="goldenArn"
                disabled={isCheckboxDisabled}
                checked={isCheckboxChecked}
              />
              <div className="relative ">
                <input
                  type="text"
                  placeholder={placeholder}
                  className={` min-w-[320px] border border-gray-300 text-gray-700 rounded-md px-4 py-2 shadow-sm focus:outline-none focus:ring focus:ring-blue-300 ${isLoading ? "pr-10" : ""
                    }`}
                  onChange={handleChange}
                  value={value}
                />
                {isLoading && (
                  <div className="absolute inset-y-0 right-3 flex items-center">
                    <RiLoader4Line className="w-5 h-5 text-gray-500 animate-spin" />
                  </div>
                )}

              </div>
            </div>

            <div className="w-[350px]  p-1 md:p-0 md:w-[360px]">
              <input
                type="text"
                placeholder="ARN Number"
                className="w-full border border-gray-300 text-gray-500 rounded-md px-4 py-2 shadow-sm focus:outline-none focus:ring focus:ring-blue-300"
                autoComplete="off"
                value={arnValue}
                readOnly
              />
            </div>
            {/* change here */}
            {/* Suggestion lists (unchanged) */}
            {/* {isDropdownOpen &&
              selectedValue === "Account Name" &&
              AccountName &&
              isGoldenArn === false &&
              value &&
              Array.isArray(AccountName) &&
              AccountName.length > 0 && (
                <ul className="absolute left-1/2 transform -translate-x-1/2 w-[28%] max-h-[50%] overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg mt-6 m-8 top-24 z-[1000]">
                  {AccountName.map((result, index) => {
                    return result && result._source ? (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200 flex justify-between items-center"
                        onClick={() => handleSuggestionClick(result)}
                      >
                        <span>
                          {result.buckets[0].key
                            ? result._source.PAR_ACCNT_NAME1
                            : "Data Not Found!"}

                          {searchData}
                        </span>
                        <span>
                          {parentarn === childarn ? (
                            <span className="text-green-600 text-sm">G</span>
                          ) : (
                            <span className="text-red-600 text-sm">
                              C
                            </span>
                          )}


                        </span>
                        <span className="text-gray-600">
                          {`${Number.isInteger(result?._source?.child_count)
                            ? result._source.child_count
                            : "-"} / ${Number.isInteger(result?._source?.Vehicle_count)
                              ? result._source.Vehicle_count
                              : "-"}`}
                        </span>

                      </li>
                    ) : (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(result)}
                      >
                        "Data Not Found!"
                      </li>
                    );
                  })}
                </ul>
              )} */}


            {/* {isDropdownOpen && selectedValue === "Account Name" && "yes"} */}





            {isDropdownOpen &&
              selectedValue === "Account Name" &&
              Array.isArray(AccountName) &&
              AccountName.length > 0 && value &&
              (
                <ul className="absolute left-1/2 -translate-x-[60%] w-[28%] max-h-[50%] overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg mt-6 m-2 top-24 z-[1000]">
                  {AccountName.map((bucket, index) => {
                    const hits = bucket?.parent_source?.hits?.hits || [];
                    const source = hits[0]?._source;
                    // console.log("api", source)
                    return (
                      <li
                        key={index}
                        className="p-2 border-b border-gray-200 last:border-b-0"
                      >
                        {/* G row - Golden/Parent Account - Clickable */}
                        <div
                          className="flex items-center justify-between mb-1 p-2 rounded hover:bg-gray-100 cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSuggestionClick(bucket, 'parent');
                          }}
                        >
                          <div className="flex items-center gap-2">
                            <span className="font-medium">{bucket.key}</span>
                            <span className="text-green-600 font-semibold">G</span>
                          </div>
                          <span className="text-gray-600 text-sm">
                            {bucket?.total_vehicle_count?.value}
                          </span>
                        </div>

                        {hits.map((hit, childIndex) => (
                          <div
                            key={childIndex}
                            className="flex items-center justify-between ml-4 mt-1 p-2 rounded hover:bg-gray-100 cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSuggestionClick(hit, 'child');
                            }}
                          >
                            <div className="flex items-center gap-2">
                              <span className="font-normal text-sm">
                                {hit._source.PAR_ACCNT_NAME1}
                              </span>
                              <span className="text-red-600 font-semibold text-sm">C</span>
                            </div>
                            <span className="text-gray-600 text-sm">
                              {hit.sort ?? "-"}
                            </span>
                          </div>
                        ))}
                      </li>
                    );
                  })}
                </ul>
              )}


            {isDropdownOpen &&
              selectedValue === "Account Name" &&
              GoldenAccountName &&
              isGoldenArn === true &&
              value &&
              Array.isArray(GoldenAccountName) &&
              GoldenAccountName.length > 0 && (
                <ul className="absolute left-1/2 -translate-x-[60%] w-[28%] max-h-[50%] overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg mt-6 m-2 top-24 z-[1000]">

                  {GoldenAccountName.map((result, index) => {
                    const source = result?._source;

                    if (!source) return null;

                    return (
                      <li
                        key={index}
                        className="p-2 border-b border-gray-200 last:border-b-0"
                      >
                        {/* Parent / Golden Row */}
                        <div
                          className="flex items-center justify-between mb-1 p-2 rounded hover:bg-gray-100 cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSuggestionClick(result);
                          }}
                        >
                          <div className="flex items-center gap-2">
                            {/* ✅ Parent Account Name */}
                            <span className="font-medium">
                              {source.PAR_ACCNT_NAME}
                            </span>
                            <span className="text-green-600 font-semibold">G</span>
                          </div>

                        </div>
                      </li>
                    );
                  })}
                </ul>
              )}




            {/* {isDropdownOpen &&
              selectedValue === "Account Name" &&
              GoldenAccountName &&
              isGoldenArn === true &&
              value &&
              Array.isArray(GoldenAccountName) &&
              GoldenAccountName.length > 0 && (
                <ul className="absolute  z-[1000] w-[28%] max-h-[50%] overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg mt-6 m-8 top-24">
                  {GoldenAccountName.map((result, index) => {
                    return result && result._source ? (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(result)}
                      >
                        {result._source.PAR_ACCNT_NAME
                          ? result._source.PAR_ACCNT_NAME
                          : "Data Not Found!"}
                      </li>
                    ) : (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(result)}
                      >

                      </li>
                    );
                  })}
                </ul>
              )} */}

            {isDropdownOpen &&
              selectedValue === "ARN Number" &&
              ArnNumber &&
              isGoldenArn === false &&
              Array.isArray(ArnNumber) &&
              ArnNumber.length > 0 && (
                <ul className="absolute left-1/2 -translate-x-[60%] z-[1000] w-[28%] max-h-[50%] overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg mt-6 m-8 top-24">
                  {ArnNumber.map((result, index) =>
                    result && result._source ? (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(result)}
                      >
                        {result._source.PAR_ACCNT_ARN
                          ? result._source.PAR_ACCNT_ARN
                          : "Data Not Found!"}
                      </li>
                    ) : (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(result)}
                      >
                        "Data Not Found!"
                      </li>
                    )
                  )}
                </ul>
              )}

            {isDropdownOpen &&
              selectedValue === "ARN Number" &&
              GoldenArnNumber &&
              isGoldenArn === true &&
              value &&
              Array.isArray(GoldenArnNumber) &&
              GoldenArnNumber.length > 0 && (
                <ul className="absolute left-1/2 -translate-x-[60%] z-[1000] w-[28%] max-h-[50%] overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg mt-6 m-8 top-24">
                  {GoldenArnNumber.map((result, index) =>
                    result && result._source ? (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(result)}
                      >
                        {result._source.PAR_ACCNT_ARN
                          ? result._source.PAR_ACCNT_ARN
                          : "Data Not Found!"}
                      </li>
                    ) : (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(result)}
                      >
                        "Data Not Found!"
                      </li>
                    )
                  )}
                </ul>
              )}

            {isDropdownOpen &&
              selectedValue === "Vehicle Registration Number" &&
              vehicleRegistrationNumber &&
              Array.isArray(vehicleRegistrationNumber) &&
              vehicleRegistrationNumber.length > 0 && (
                <ul className="absolute left-1/2 -translate-x-[60%] z-[1000] w-[28%] max-h-[50%] overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg mt-6 m-8 top-24">
                  {vehicleRegistrationNumber.map((result, index) =>
                    result && result._source ? (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(result)}
                      >
                        {result._source.VEHICLE_REGISTRATION_NUMBER
                          ? result._source.VEHICLE_REGISTRATION_NUMBER
                          : "Data Not Found!"}
                      </li>
                    ) : (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(result)}
                      >
                        "Data Not Found!"
                      </li>
                    )
                  )}
                </ul>
              )}

            {isDropdownOpen &&
              selectedValue === "Key Account Code" &&
              KeyAccountLocation &&
              Array.isArray(KeyAccountLocation) &&
              KeyAccountLocation.length > 0 && (
                <ul className="absolute left-1/2 -translate-x-[60%] z-[1000] w-[28%] max-h-[50%] overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg mt-6 m-8 top-24">
                  {KeyAccountLocation.map((result, index) =>
                    result && result._source ? (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(result)}
                      >
                        {result._source.PAR_ACCNT_LOCATION
                          ? result._source.PAR_ACCNT_LOCATION
                          : "Data Not Found!"}
                      </li>
                    ) : (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(result)}
                      >
                        "Data Not Found!"
                      </li>
                    )
                  )}
                </ul>
              )}

            {isDropdownOpen &&
              selectedValue === "Chassis Number" &&
              fetchChassisNumberData &&
              Array.isArray(fetchChassisNumberData) &&
              fetchChassisNumberData.length > 0 && (
                <ul className="absolute left-1/2 -translate-x-[60%] z-[1000] w-[28%] max-h-[50%] overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg mt-6 m-8 top-24">
                  {fetchChassisNumberData.map((result, index) =>
                    result && result._source ? (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(result)}
                      >
                        {result._source.ASSET_NUMBER
                          ? result._source.ASSET_NUMBER
                          : "Data Not Found!"}
                      </li>
                    ) : (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(result)}
                      >
                        "Data Not Found!"
                      </li>
                    )
                  )}
                </ul>
              )}

            {isDropdownOpen &&
              selectedValue === "Primary Contact Number" &&
              fetchPhoneNumberData &&
              Array.isArray(fetchPhoneNumberData) &&
              fetchPhoneNumberData.length > 0 && (
                <ul className="absolute left-1/2 -translate-x-[60%] z-[1000] w-[20%] max-h-[50%] overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg mt-6 m-8 top-24">
                  {fetchPhoneNumberData.map((result, index) =>
                    result && result._source ? (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(result)}
                      >
                        {result._source.PAR_ACCNT_MAIN_PH_NUM
                          ? maskPhoneNumber(result._source.PAR_ACCNT_MAIN_PH_NUM)
                          : "Data Not Found!"}
                      </li>
                    ) : (
                      <li
                        key={index}
                        className="p-2 cursor-pointer text-slate-900 hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(result)}
                      >
                        "Data Not Found!"
                      </li>
                    )
                  )}
                </ul>
              )}


            <button onClick={handleReset} className="px-3 py-1 bg-gray-200 rounded-md text-gray-600 border">Reset</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Search;
